/* Custom Pluszkowo consent UI; Shopify remains the source of consent truth. */
(function () {
  'use strict';
  var box = document.querySelector('[data-cookie-banner]');
  if (!box) return;
  var api, loading = false, pendingOpen = false, busy = false, opener;
  var key = 'pluszkowo-consent-v1';
  var choices = box.querySelectorAll('[data-cookie-choice]');
  var preferences = box.querySelector('[data-cookie-preferences]');
  var error = box.querySelector('[data-cookie-error]');
  var settings = box.querySelector('[data-cookie-action="settings"]');
  var save = box.querySelector('[data-cookie-action="save"]');
  function read() { try { return JSON.parse(localStorage.getItem(key)) || {}; } catch (e) { return {}; } }
  function consent() { return api.currentVisitorConsent() || {}; }
  function decided(c) { return ['analytics', 'marketing', 'preferences'].every(function (k) { return c[k] === 'yes' || c[k] === 'no'; }); }
  function fill(c) { choices.forEach(function (i) { i.checked = c[i.dataset.cookieChoice] === 'yes'; }); }
  function show(custom) {
    fill(consent());preferences.hidden = !custom;settings.hidden = !!custom;save.hidden = !custom;
    settings.setAttribute('aria-expanded', String(!!custom));error.hidden = true;
    var art = box.querySelector('[data-cookie-art]');
    if (!art.src) { art.srcset = art.dataset.srcset;art.src = art.dataset.src; }
    box.hidden = false;document.documentElement.classList.add('cookie-book-open');
    if (custom) box.querySelector('h2').focus({ preventScroll: true });
  }
  function hide() {
    box.hidden = true;document.documentElement.classList.remove('cookie-book-open');
    if (opener && opener.isConnected) opener.focus({ preventScroll: true });
  }
  function ready() {
    api = window.Shopify && window.Shopify.customerPrivacy;
    if (!api || typeof api.setTrackingConsent !== 'function') return;
    loading = false;document.documentElement.classList.add('pluszkowo-custom-privacy');
    if (pendingOpen) { pendingOpen = false;show(true); }
    else if (!decided(consent()) && api.shouldShowBanner()) show(false);
  }
  function load(attempt) {
    if (window.Shopify && window.Shopify.customerPrivacy) { ready();return; }
    if (window.Shopify && window.Shopify.loadFeatures && !loading) {
      loading = true;
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        loading = false;if (!err) ready();
        else if (pendingOpen) { pendingOpen = false;showUnavailable(); }
      });return;
    }
    if (attempt < 12) setTimeout(function () { load(attempt + 1); }, 250);
    else if (pendingOpen) { pendingOpen = false;showUnavailable(); }
  }
  function showUnavailable() {
    box.hidden = false;error.hidden = false;error.textContent = 'Nie udało się wczytać ustawień. Odśwież stronę i spróbuj ponownie.';
    // The standard Shopify banner remains available when the API fails.
    box.querySelectorAll('button').forEach(function (b) { b.disabled = true; });
  }
  function persist(value) {
    if (busy || !api) return;busy = true;error.hidden = true;
    var buttons = box.querySelectorAll('button');buttons.forEach(function (b) { b.disabled = true; });
    var timer = setTimeout(function () { done({ error: true }); }, 8000), finished = false;
    function done(result) {
      if (finished) return;finished = true;clearTimeout(timer);busy = false;
      buttons.forEach(function (b) { b.disabled = false; });
      if (result && result.error) { error.textContent = 'Nie zapisaliśmy wyboru. Spróbuj ponownie.';error.hidden = false;return; }
      try { localStorage.setItem(key, JSON.stringify({ analytics:value.analytics, marketing:value.marketing, preferences:value.preferences, savedAt:Date.now() })); } catch (e) {}
      hide();
    }
    try { api.setTrackingConsent(value, done); } catch (e) { done({ error:true }); }
  }
  box.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cookie-action]');if (!b) return;
    var action = b.dataset.cookieAction;
    if (action === 'settings') { show(true);return; }
    var value = { analytics:false, marketing:false, preferences:false };
    if (action === 'accept') Object.keys(value).forEach(function (k) { value[k] = true; });
    if (action === 'save') choices.forEach(function (i) { value[i.dataset.cookieChoice] = i.checked; });
    persist(value);
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cookie-open]');if (!b) return;
    e.preventDefault();opener = b;
    if (api) show(true);else { pendingOpen = true;load(0); }
  });
  document.addEventListener('visitorConsentCollected', function () { if (!busy && api && decided(consent())) hide(); });
  window.addEventListener('pageshow', function () { if (api && decided(consent())) hide(); });
  // Local preview only: simulate the documented API without reaching the shop.
  if (window.Pluszkowo && window.Pluszkowo.preview && !(window.Shopify && window.Shopify.customerPrivacy)) {
    var mock = read();window.Shopify = window.Shopify || {};
    window.Shopify.customerPrivacy = {
      currentVisitorConsent:function () { var c={};['analytics','marketing','preferences'].forEach(function (k) { c[k] = typeof mock[k] === 'boolean' ? (mock[k] ? 'yes' : 'no') : ''; });return c; },
      shouldShowBanner:function () { return true; },
      setTrackingConsent:function (c, cb) { mock = c;cb(); }
    };
  }
  load(0);
}());
